export function ProseBlock({
  paragraphs
}: {
  paragraphs: string[];
}) {
  return <div className="max-w-2xl space-y-4" data-id="element-326" data-mp="1fggkqhycs76j">
      {paragraphs.map(p => <p key={p.slice(0, 48)} className="text-white/65 text-base leading-relaxed" data-id="element-327" data-mp="o96njchr5oea">
          {p}
        </p>)}
    </div>;
}